module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_3.87fa7db2.pdf";